import { Modal, MuniSpinner2 } from "../../../components";
import FormMarcarActaComoImpresa from "../../../screens/Actas/Acta/Formularios/FormMarcarActaComoImpresa";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useActasStore } from "../../../store/actasStore";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const ModalImpresaActa = ({ modals, handlerModal, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { acta } = useActaDetalleStore()
    const { setActaDetalle } = useActasStore()
    const { loads } = useGeneralAppStore();

    return (
        <>
            <Modal
                show={modals.includes('impresa_acta_detalle')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "impresa_acta_detalle" })}
                title={() => "Imprimir acta"}
            >


                {/* <>
                    {acta.fecha_impresion
                        ? `Acta impresa el ${acta.fecha_impresion}`
                        : "Marcar acta como impresa físicamente"}
                </>, */}
                <div className="position-relative">
                    {
                        loads.includes('impresa_acta_detalle') &&
                        <div className="position-absolute w-100 h-100 " style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    {acta.fecha_impresion
                        ?
                        <div>
                            <p>El acta ya tiene fecha de impresa</p>
                            <div className="d-flex justify-content-center">
                                <span className="fw-bold">{acta?.fecha_impresion}</span>
                            </div>
                        </div>
                        : (
                            <FormMarcarActaComoImpresa acta={acta} setActa={setActaDetalle} setRefetch={setRefetch} />
                        )}
                </div>
            </Modal >
        </>
    );
}
export default ModalImpresaActa;